import PropTypes from "prop-types";
import React from "react";
import client from "../../../shared/api/client";
import { Button } from "@opendate-app/setlist";

const PendingGiftNotice = ({ gift }) => {
  const [confirming, setConfirming] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [error, setError] = React.useState(null);
  const confirmRef = React.useRef(null);
  const cancelTriggerRef = React.useRef(null);
  const interacted = React.useRef(false);

  React.useEffect(() => {
    if (!interacted.current) {
      interacted.current = true;
      return;
    }
    if (confirming) {
      confirmRef.current?.querySelector("button")?.focus();
    } else {
      cancelTriggerRef.current?.querySelector("button")?.focus();
    }
  }, [confirming]);

  const cancelGift = () => {
    setSubmitting(true);
    setError(null);
    client
      .patch(gift.recallPath)
      .then(() => window.location.reload())
      .catch((e) => {
        setSubmitting(false);
        setError(e.response?.data?.errors?.[0] || "Something went wrong. Please try again.");
      });
  };

  return (
    <div className="fan-order-delivery-notice">
      <i className="far fa-exchange fan-order-delivery-notice-icon" />
      <span>Transfer pending &mdash; waiting for {gift.email} to accept. Cancel the transfer to list or send these tickets.</span>
      {confirming ? (
        <span ref={confirmRef} className="ml-auto d-flex align-items-center">
          <span className="mr-2">Cancel this transfer?</span>
          <Button variant="secondary" size="sm" className="mr-2" onClick={() => setConfirming(false)} disabled={submitting} aria-label="Keep this transfer">
            Keep
          </Button>
          <Button variant="destructive" size="sm" onClick={cancelGift} disabled={submitting} aria-label="Yes, cancel this transfer">
            {submitting ? "Canceling..." : "Yes, cancel"}
          </Button>
        </span>
      ) : (
        <span ref={cancelTriggerRef} className="ml-auto">
          <Button variant="destructive" size="sm" onClick={() => setConfirming(true)} aria-label={`Cancel the transfer to ${gift.email}`}>
            Cancel transfer
          </Button>
        </span>
      )}
      {error && <span className="text-danger ml-2" role="alert">{error}</span>}
    </div>
  );
};

PendingGiftNotice.propTypes = {
  gift: PropTypes.shape({
    id: PropTypes.number.isRequired,
    email: PropTypes.string.isRequired,
    recallPath: PropTypes.string.isRequired,
  }).isRequired,
};

export default PendingGiftNotice;
